import { cached } from '@porotutu/react'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { signedInRoute } from '@/router/root'
import { roleMatrixQuery } from './queries'

export const rolesRoute = createRoute({
  getParentRoute: () => signedInRoute,
  path: '/roles',
  loader: ({ context }) => context.queryClient.query(cached(roleMatrixQuery)),
  component: lazyRouteComponent(() => import('./pages'), 'RolesPage'),
})

export const rolesRoutes = [rolesRoute]
